<template>
  <div class="no-results" v-show="listIsEmpty">
    <font-awesome-icon
      icon="circle-exclamation"
      size="1x"
      color="grey-5"
      class="q-mb-md"
      v-show="!searchTextIsEmpty"
    />
    
    <p v-show="!searchTextIsEmpty"> 
      Sorry, we didn't find any results, try again
    </p>
    <p v-show="searchTextIsEmpty">
      Empty list
    </p>
  </div>
</template>

<script>
export default {
  name: 'EmptyList',
  props: {
    listIsEmpty: {
      type: Boolean,
      required: true
    },
    searchTextIsEmpty: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.no-results {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>